import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { TransactionsApi, type CreateTransactionReceiptRequest, type TransactionResponse } from '@shared/api';

const createReceiptTransactionEffect = createEffect((request: CreateTransactionReceiptRequest) => TransactionsApi.createReceiptTransaction(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransactionResponse | null>(null)
  .on(createReceiptTransactionEffect.done, (current, result) => result.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(createReceiptTransactionEffect.pending, (_, data) => data)
  .on(createReceiptTransactionEffect.fail, () => false)
  .on(createReceiptTransactionEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(createReceiptTransactionEffect, () => null)
  .on(
    createReceiptTransactionEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while creating Transaction Receipt. Please try again.').message,
  )
  .on(createReceiptTransactionEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $createReceiptTransactionStore = {
  events: {
    createReceiptTransaction: createReceiptTransactionEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
